import React from 'react';

function FaqsHeaderwidget(props: any) {
  return (
    <div className="faq-header-container-background">
      <div className="container">
        <h1 className="faq-title-h1">{props.data.title}</h1>
      </div>
    </div>
  );
}

export default FaqsHeaderwidget;
